import { createFileRoute } from "@tanstack/react-router";
import { CollapsibleExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/interactive/collapsible",
)({
  component: CollapsibleExamples,
});
